import { FetchService } from '@/dmdrive/core/service/FetchService';
import { SnapshotModel } from '@/dmdrive/topic/entities/Snapshot';
import { TopicMeta, TopicModel } from '@/dmdrive/topic/entities/Topic';
import { CreateTopicMarkModel } from '@/dmdrive/topic/entities/TopicMark';
import { SnapshotValues } from '@/dmdrive/topic/types/SnapshotValues';

const PATH_TOPIC = '/conference/topic';

export class TopicAPI {
  getTopicById(id: string) {
    return FetchService.get<TopicModel>(`${PATH_TOPIC}/${id}`);
  }

  updateTopic(id: string, body: TopicMeta) {
    return FetchService.patch(`${PATH_TOPIC}/${id}`, {
      body,
    });
  }

  addTopicMarks(topicId: string, entries: CreateTopicMarkModel[]) {
    return FetchService.post<TopicModel>(`${PATH_TOPIC}/${topicId}/marks`, {
      body: { entries },
    });
  }

  updateTopicMarks(topicId: string, entries: CreateTopicMarkModel[]) {
    return FetchService.put<TopicModel>(`${PATH_TOPIC}/${topicId}/marks`, {
      body: { entries },
    });
  }

  deleteTopicMarks(topicId: string, ids: string[]) {
    return FetchService.remove<TopicModel>(`${PATH_TOPIC}/${topicId}/marks`, {
      body: {
        entries: ids.map((id) => ({ id })),
      },
    });
  }

  createTopicSnapshot(topicId: string, body: SnapshotValues) {
    return FetchService.post<SnapshotModel>(`${PATH_TOPIC}/${topicId}/snapshots`, { body });
  }

  updateTopicSnapshot(topicId: string, snapshotId: string, body: SnapshotValues) {
    return FetchService.put<SnapshotModel>(`${PATH_TOPIC}/${topicId}/snapshots/${snapshotId}`, { body });
  }

  deleteTopicSnapshot(topicId: string, snapshotId: string) {
    return FetchService.remove<void>(`${PATH_TOPIC}/${topicId}/snapshots/${snapshotId}`);
  }
}
